import React, { FC } from 'react'

import type { CustomIconComponentProps } from 'src/icons/antd-compat'
import Icon from 'src/icons/antd-compat'

export type TWhAntdIconProps = Pick<Partial<CustomIconComponentProps>, 'style'>

export const createAntdIcon =
  (Svg: FC) => (props: Partial<CustomIconComponentProps>) =>
    <Icon component={Svg} {...props} />
